import { render, staticRenderFns } from "./UpgradeCanpayWithEmail.vue?vue&type=template&id=63ab13ac&"
import script from "./UpgradeCanpayWithEmail.vue?vue&type=script&lang=js&"
export * from "./UpgradeCanpayWithEmail.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeCanpayWithEmail.vue?vue&type=style&index=0&id=63ab13ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports